<span [class]="cssClass"><ng-content /></span>
